const ComplexAreaPriceTable = (props) => {
    const getDealPriceData = (content) => {
        // init
        content.forEach(v => {
            v.range = Math.floor(v.dealPrice / 10000) * 10000;
        });
        content.sort((v1, v2) => v2.dealPrice - v1.dealPrice);

        // y-axis
        const maxDealPrice = content.map(v => v.range).filter(v => v > 0).reduce((v1, v2) => v1 > v2 ? v1 : v2, 0);
        const dealPriceRange = [];
        for (var i = maxDealPrice; i > 0; i -= 10000) { dealPriceRange.push(i); }

        // x-axis
        const livingAreaRange = Object.keys(Object.groupBy(content, v => v.complex.livingAreaName));

        // fill content
        const rangeInit = {};
        dealPriceRange.forEach(prc => rangeInit[prc] = []);
        const rangeByData = Object.groupBy(content, v => v.range);
        const rangeMap = { ...rangeInit, ...rangeByData };

        Object.keys(rangeMap).forEach(range => {
            const groupInit = {};
            livingAreaRange.forEach(area => groupInit[area] = []);
            const groupByContent = Object.groupBy(rangeMap[range], v => v.complex.livingAreaName);
            rangeMap[range] = { ...groupInit, ...groupByContent };
        });

        return {
            yAxis: dealPriceRange,
            xAxis: livingAreaRange,
            dataMap: rangeMap
        };
    };

    const data = getDealPriceData(props.content);

    return (<>
        <table className={"table table-sm"}>
            <thead>
                <tr>
                    <th>금액</th>
                    {data.xAxis.map(v => <th key={v}>{v}</th>)}
                </tr>
            </thead>
            <tbody>
                {data.yAxis.map(prc => <tr key={prc}><td>{prc/10000}억</td>{data.xAxis.map(area => <ComplexAreaPriceTableColumn key={area} content={data.dataMap[prc][area]} />)}</tr>)}
            </tbody>
        </table>
    </>);
};

const ComplexAreaPriceTableColumn = (props) => {
    const { content } = props;
    return (<td style={{ fontSize: "0.9em" }}>
        {content.map(v => <div style={{ color: v.complex.age <= 10 ? "orangered" : v.complex.age <= 25 ? "teal" : "darkblue" }} key={v.complexAreaId}>{v.complex.name}/{v.generalExclusiveArea} - {(v.dealPrice / 10000).toFixed(1)}억</div>)}
    </td>)
}

export { ComplexAreaPriceTable };
